/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BasePurchase } from './BasePurchase';
import { TenantAccessPlan } from './TenantAccessPlan';
const UserAccessPassParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['scope', /* #__PURE__ */ parsers.exactly('access-plan')],
    ['purchasedItem', TenantAccessPlan, 'purchased_item'],
]), BasePurchase);
export class UserAccessPass extends BasePurchase {
    static decode(input) {
        return UserAccessPassParser.decode(input).map(res => new UserAccessPass(res));
    }
    static unsafeDecode(input) {
        return UserAccessPass.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UserAccessPassParser.encode(data);
    }
    static schema() {
        return UserAccessPassParser.schema();
    }
}
